// src/components/dashboard/EmptyState.tsx
import React, { memo } from "react";

interface EmptyStateProps {
  onCreateClick: () => void;
}

export const EmptyState = memo(({ onCreateClick }: EmptyStateProps) => (
  <div className="h-[50vh] flex flex-col items-center justify-center opacity-20 text-center">
    <p className="uppercase font-black tracking-[0.5em] mb-4">
      No Creations Found
    </p>
    <button
      onClick={onCreateClick}
      className="text-xs underline tracking-widest hover:opacity-100 transition-opacity"
    >
      Start your first journey
    </button>
  </div>
));

EmptyState.displayName = "EmptyState";
